import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import { StickyContainer } from 'react-sticky';
import { get } from 'lodash';
import ApplicationStore from '../../stores/ApplicationStore';
import DocumentStore from '../../stores/DocumentStore';
import NavigationStore from '../../stores/NavigationStore';
import initSampleBox from '../../browser/sampleBox';
import ContentRenderer from '../ContentRenderer';
import NavigationBar from '../NavigationBar';
import ArticleFooter from '../ArticleFooter';
import Sidebar from '../Sidebar';
import Spinner from '../Spinner';
import Breadcrumbs from '../Breadcrumbs';

class ArticlePage extends React.Component {
  runHooksAfterRender = () => {
    this.executeEmbeddedScripts();
    initSampleBox();
  }

  executeEmbeddedScripts = () => {
    $('script', this.content).each((idx, item) => {
      if (item.src) {
        $(item).remove();
        const el = document.createElement('script');
        el.src = item.src;
        document.body.appendChild(el);
      } else {
        $.globalEval(item.text || item.textContent || item.innerHTML || '');
      }
    });
  }

  renderContent(breadcrumbs) {
    const { url, doc } = this.props;

    // If the document hasn't been loaded yet, display a spinner.
    if (!doc || !doc.html || !doc.meta) {
      return (<Spinner />);
    }

    return (
      <div className="docs-content-container">
        <Breadcrumbs crumbs={breadcrumbs} />
        <article
          className={`docs-content ${doc.meta.classes || ''}`}
          data-swiftype-name="body"
          data-swiftype-type="text"
          data-swiftype-index="true"
        >
          <ContentRenderer
            html={doc.html}
            meta={doc.meta}
            afterRender={this.runHooksAfterRender}
          />
        </article>
        <ArticleFooter articleUrl={url} githubEditLink={doc.meta.editUrl} />
      </div>
    );
  }

  render() {
    const {
      doc,
      breadcrumbs,
      sidebarBreadcrumbs,
      sidebarArticles,
      url
    } = this.props;

    // TODO: Sidebar needs to not update until all this is ready again
    const section = (doc && doc.meta) ? doc.meta.section : undefined;

    return (
      <div
        className={`
          docs-article
          doc-with-sidebar
          ${get(this.props, 'doc.meta.toc') ? 'docs-with-toc' : ''}
        `}
      >
        <div className="document">
          <NavigationBar currentSection={section} />
          <StickyContainer>
            <div className="js-doc-template container" style={{ marginBottom: '40px' }}>
              <div className="row">
                <div className="sidebar-container col-md-3">
                  <Sidebar
                    section={section}
                    items={sidebarArticles}
                    maxDepth={3}
                    breadcrumbs={sidebarBreadcrumbs}
                    url={url}
                  />
                </div>
                <div className="col-md-9">
                  <div ref={e => (this.content = e)}>
                    {this.renderContent(breadcrumbs)}
                  </div>
                </div>
              </div>
            </div>
          </StickyContainer>
        </div>
      </div>
    );
  }
}

ArticlePage.propTypes = {
  doc: PropTypes.object,
  url: PropTypes.string,
  breadcrumbs: PropTypes.array,
  sidebarBreadcrumbs: PropTypes.array,
  sidebarArticles: PropTypes.array
};

export default connectToStores(ArticlePage,
  [
    ApplicationStore,
    DocumentStore,
    NavigationStore
  ],
  (context, props) => {
    const docStore = context.getStore(DocumentStore);
    const navigationStore = context.getStore(NavigationStore);

    const { url } = props.currentRoute;
    const doc = docStore.getDocument(url);

    let breadcrumbs = [];
    let sidebarArticles = [];
    let sidebarBreadcrumbs = [];

    if (doc && doc.meta) {
      breadcrumbs = navigationStore.getBreadcrumbs();
      sidebarBreadcrumbs = navigationStore.getSidebarBreadcrumbs();
      sidebarArticles = navigationStore.getSidebarArticles(doc.meta.section);
    }

    return {
      url,
      doc,
      breadcrumbs,
      sidebarBreadcrumbs,
      sidebarArticles
    };
  }
);
